import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
import {FormControl} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {ProviderModel} from '../../../../models/ProviderModel';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {RegionModel} from '../../../../models/RegionModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {SizeModel} from '../../../../models/SizeModel';
import {SiteModel} from '../../../../models/SiteModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import { ServiceChangesService } from 'src/app/service-changes/service/service-changes.service';

@Component({
  selector: 'app-provider-filter',
  templateUrl: './provider-filter.component.html',
  styleUrls: ['./provider-filter.component.scss']
})
export class ProviderFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listProviderFilter: any[];
  optionSelected: any;
  formControl: FormControl = new FormControl();
  filteredOptions: BehaviorSubject<ProviderModel[]> = new BehaviorSubject<ProviderModel[]>([]);

  filterAllSettings: AllSettingsFilterModel;

  @Input() userProviderList: any;
  @Input() providerData: any;
  @Input() providerSelected: ProviderModel;

  @Input() noAutocompleteForm: boolean;

  @Input() inAllSettings?: boolean;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;
  @Input() sizeForFilterInSettings?: SizeModel;
  @Input() siteForFilterInSettings?: SiteModel;

  @Input() numAnnoMeseFromForFilterInSettings: number;
  @Input() numAnnoMeseToForFilterInSettings: number;

  constructor(private providerAnagrafService: ProviderAnagrafService, private serviceChangesService: ServiceChangesService) {
    super();
  }

  public getProviderSelected(): void {
    this.serviceChangesService.providerFilterValue$.next(this.providerSelected);
    this.dataFiltered.emit(this.providerSelected);
  }

  ngOnInit() {
    this.fetchFilterData();
    this.formControl.setValue(this.providerSelected ? this.providerSelected.cod : null);
    this.formControl.valueChanges
      .subscribe(value => {
        const result = this._filter(value);
        this.filteredOptions.next(result);
        this.dataFiltered.emit(this.filteredOptions.value.find(x => x.cod === value || x.description === value));
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('providerData' in changes) {
      this.listProviderFilter = this.providerData;
      this.optionSelected = null;
    }
    if (this.providerSelected) {
      if (this.noAutocompleteForm) {
        this.providerSelected = this.listProviderFilter.find(x => x.cod === this.providerSelected.cod);
      }
      this.optionSelected = this.providerSelected ? this.providerSelected.cod : null;
    }
    if (
      'regionForFilterInSettings' in changes ||
      'localCustomerForFilterInSettings' in changes ||
      'contractTypeForFilterInSettings' in changes ||
      'resourceUnitForFilterInSettings' in changes ||
      'sizeForFilterInSettings' in changes ||
      'siteForFilterInSettings' in changes
    ) {
      this.fetchFilterData();
    } else {
      this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
    }
  }

  fetchFilterData() {
    if (this.inAllSettings) {
      this.filterAllSettings = new AllSettingsFilterModel(
        this.regionForFilterInSettings,
        this.localCustomerForFilterInSettings,
        this.resourceUnitForFilterInSettings,
        this.providerSelected,
        this.contractTypeForFilterInSettings,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.sizeForFilterInSettings?.cod ? this.sizeForFilterInSettings : null,
        this.siteForFilterInSettings,
        null,
        null,
        null,
        null
      );
      this.providerAnagrafService.getListInAllSettings(
        this.providerAnagrafService.baseUrl,
        this.filterAllSettings)
        .subscribe(
          (result: any) => {
            this.listProviderFilter = this.providerData = result;
            // this.optionSelected = null;
            this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
          });
    }
  }

  private _filter(value: string): ProviderModel[] {
    const filterValue = value ? value.toLowerCase() : '';
    if (!this.providerData) {
      return [];
    }
    return this.providerData.filter(
      option => option.cod.toLowerCase().includes(filterValue) || option.description.toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy(): void {
  }
}
